(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.editorialReady) return;
    root.dataset.editorialReady = 'true';
    var slides = Array.from(root.querySelectorAll('[data-nt-editorial-slide]'));
    var dots = Array.from(root.querySelectorAll('[data-nt-editorial-dot]'));
    var status = root.querySelector('[data-nt-editorial-status]');
    var videos = Array.from(root.querySelectorAll('[data-nt-hero-video]'));
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    function syncVideo() {
      videos.forEach(function (video) {
      var active = video.closest('[data-nt-editorial-slide]').classList.contains('is-active');
      if (!active || document.hidden || reduced.matches) { video.pause(); return; }
      var source = video.querySelector('source');
      if (!source.src) { source.src = source.dataset.src; video.load(); }
      video.muted = true;
      video.play().catch(function () {});
      });
    }
    if (videos.length) {
      document.addEventListener('visibilitychange', syncVideo);
      reduced.addEventListener('change', syncVideo);
    }
    var index = 0;
    var start = null;
    function show(next, announce) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      syncVideo();
      if (announce) status.textContent = slides[index].getAttribute('aria-label') + ': ' + slides[index].querySelector('h1,h2').textContent;
    }
    if (slides.length < 2) { syncVideo(); return; }
    root.querySelector('[data-nt-editorial-prev]').addEventListener('click', function () { show(index - 1, true); });
    root.querySelector('[data-nt-editorial-next]').addEventListener('click', function () { show(index + 1, true); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { show(i, true); }); });
    root.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      if (!event.target.closest('button')) return;
      event.preventDefault();
      show(index + (event.key === 'ArrowLeft' ? -1 : 1), true);
    });
    root.querySelectorAll('.nt-editorial-hero__media').forEach(function (media) {
      media.style.touchAction = 'pan-y';
      media.addEventListener('touchstart', function (event) {
        start = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { passive: true });
      media.addEventListener('touchend', function (event) {
        if (!start || !event.changedTouches.length) return;
        var dx = event.changedTouches[0].clientX - start.x;
        var dy = event.changedTouches[0].clientY - start.y;
        start = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) show(index + (dx < 0 ? 1 : -1), true);
      }, { passive: true });
      media.addEventListener('touchcancel', function () { start = null; }, { passive: true });
    });
    show(0, false);
  }
  function initAll() { document.querySelectorAll('[data-nt-editorial-hero]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
}());
